import { Center } from "@mantine/core";
import { AxioLoader } from "../components/AxioLoader";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/useAuth";
import { roleHomePath } from "../lib/roles";
import type { User } from "../types/api";

interface RoleRouteProps {
  allowedRoles: User["role"][];
}

export function RoleRoute({ allowedRoles }: RoleRouteProps) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Center h="100vh">
        <AxioLoader size="lg" />
      </Center>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to={roleHomePath(user.role)} replace />;
  }

  return <Outlet />;
}
